import { flatColors } from '@/../../tailwind.utils';
import type { BuilderConfig } from '@/types/builder';
import Link from '../Link';
import { BtnContentSpacing, BtnLabelAlignment, BtnSize, BtnType, BtnVariant } from './Btn';
import Btn from './Btn.vue';

export default {
    component: Btn,
    childComponents: [Link],
    docsLink: 'https://storybook.studydrive.net/?path=/story/components-buttons-btn--docs',
    inputs: [
        {
            name: 'label',
            type: 'string',
            defaultValue: 'Button',
        },
        {
            name: 'variant',
            type: 'enum',
            enum: Object.values(BtnVariant),
        },
        {
            name: 'type',
            type: 'enum',
            enum: Object.values(BtnType),
        },
        {
            name: 'size',
            type: 'enum',
            enum: Object.values(BtnSize),
        },
        {
            name: 'contentSpacing',
            type: 'enum',
            enum: Object.values(BtnContentSpacing),
        },
        {
            name: 'labelAlign',
            type: 'enum',
            enum: Object.values(BtnLabelAlignment),
        },
        {
            name: 'href',
            type: 'url',
        },
        {
            name: 'color',
            type: 'string',
            enum: Object.keys(flatColors),
        },
        {
            name: 'contentColor',
            type: 'string',
            enum: Object.keys(flatColors),
        },
        {
            name: 'activeColor',
            type: 'string',
            enum: Object.keys(flatColors),
        },
        {
            name: 'activeContentColor',
            type: 'string',
            enum: Object.keys(flatColors),
        },
    ],
} satisfies BuilderConfig;
